import { Suspense } from "react";
import LoadingFallback from "./LoadingFallback";

export const SuspenseWrapper = ({ children }) => {
  return <Suspense fallback={<LoadingFallback />}>{children}</Suspense>;
};
